/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vocabulary } from "../Utils/Vocabulary";
import { urlEnum } from "../Utils/UrlEnum";
import MainTable from "../Components/GenericComponents/MainTable";
import { useContext, useState } from "react";
import { BrandModel } from "../Utils/Models";
import { updateData } from "../Services/updateData";
import { postData } from "../Services/postData";
import Brand from "../Components/Brands/Brand";
import { CacheWebsocketContext } from "../Contexts/WebsocketContext";

export default function Brands() {
  const websocketContext = useContext(CacheWebsocketContext);
  const [open, setOpen] = useState(false);
  const [editItem, setEditItem] = useState<BrandModel | null>(null);
  const [shouldUpdate, setShouldUpdate] = useState(false);

  const brandHeader = [
    {
      label: Vocabulary.name,
      name: "name",
      options: { sort: false },
    },
  ];

  /**
   *
   * @param item
   */
  function handleEdit(item: BrandModel | null) {
    setShouldUpdate(false);
    setOpen(!open);
    setEditItem(item);
  }

  /**
   *
   * @param brand
   */
  function addOrUpdateBrand(brand: BrandModel | null) {
    if (brand?._id) {
      updateData(`${urlEnum.brands}/${brand._id}`, brand)
        .then((res) => {
          if (res) {
            websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
            setOpen(false);
            setShouldUpdate(true);
          }
        })
        .catch((err) => {
          setOpen(false);
        });
    } else {
      postData(urlEnum.brands, brand)
        .then((res: any) => {
          if (res) {
            websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
            setOpen(false);
            setShouldUpdate(true);
          }
        })
        .catch((err) => {
          setOpen(false);
        });
    }
  }

  return (
    <div>
      <MainTable
        urlEnumApi={urlEnum.brands}
        header={brandHeader}
        tableTitle={Vocabulary.brandsList}
        deleteMessages={{
          title: Vocabulary.deleteBrand,
          text: Vocabulary.deleteConfirmationBrand,
        }}
        hideOptionButtons={{
          edit: {
            condition: (item) => false,
          },
          delete: {
            condition: (item) => false,
          },
        }}
        shouldUpdate={shouldUpdate}
        handleEdit={(item) => {
          handleEdit(item);
        }}
      />
      {open ? (
        <Brand
          editBrand={editItem}
          open={open}
          addOrUpdateBrand={(brand) => addOrUpdateBrand(brand)}
          onClose={() => handleEdit(null)}
        />
      ) : null}
    </div>
  );
}
